(function () {
    'use strict';

    angular
        .module('app')
        .controller('ProfileCardController', ProfileCardController);

    ProfileCardController.$inject = ['$scope', '$state', 'dialog', '$http'];

    function ProfileCardController($scope, $state, dialog, $http) {
        var vm = this;

        vm.showDropdown = false;

        vm.previewSpace = previewSpace;
        vm.publishSpace = publishSpace;
        vm.cancelSpace = cancelSpace;
        vm.sendSpaceToDraft = sendSpaceToDraft;
        vm.deleteSpace = deleteSpace;
        vm.setSuperhost = setSuperhost;

        vm.previewBand = previewBand;
        vm.publishBand = publishBand;
        vm.cancelBand = cancelBand;
        vm.sendBandToDraft = sendBandToDraft;
        vm.deleteBand = deleteBand;
        vm.setAllStar = setAllStar;

        vm.$onInit = function () {
            if (vm.type == 'space') {
                vm.space = vm.data; 0
            }
            if (vm.type == 'artist') {
                vm.band = vm.data;
            }
            console.log(vm);
        }

        function previewSpace(space_slug) {
            $state.go('space_preview', { space_slug: space_slug })
        }

        function publishSpace(space) {
            $http.patch('api/publish_space/' + space.space_slug + '/')
                .then(function (response) {
                    space.verified = true;
                    $scope.$applyAsync();
                });
        }

        function cancelSpace(space) {
            dialog.prompt('reject-host-submission-prompt', function (response) {
                if (response.confirm) {
                    $http.patch('api/cancel_space/' + space.space_slug + '/')
                        .then(function (response) {
                            space.rejected = true;
                            $scope.$applyAsync();
                        });
                }
            });
        }

        function sendSpaceToDraft(space) {
            $http.patch('api/send_space_to_draft/' + space.space_slug + '/')
                .then(function (response) {
                    space.drafted = true;
                    $scope.$applyAsync();
                });
        }

        function deleteSpace(space) {
            dialog.prompt('delete-space-prompt', function (response) {
                if (response.confirm) {
                    $http.delete('api/spaces/' + space.space_slug + '/')
                        .then(function () {
                            space.deleted = true;
                            $scope.$applyAsync();
                        })
                }
            });
        }

        function setSuperhost(space, value) {
            $http.patch('api/space/set_superhost/' + space.space_slug + '/' + value + '/')
                .then(function (response) {
                    space.space_superhost = value;
                    $scope.$applyAsync();
                });
        }

        function previewBand(band_slug) {
            $state.go('band_preview', { band_slug: band_slug })
        }

        function publishBand(band) {
            $http.patch('api/publish_band/' + band.band_slug + '/')
                .then(function (response) {
                    band.verified = true;
                    $scope.$applyAsync();
                });
        }

        function cancelBand(band) {
            dialog.prompt('reject-band-submission-prompt', function (response) {
                if (response.confirm) {
                    $http.patch('api/cancel_band/' + band.band_slug + '/')
                        .then(function (response) {
                            band.rejected = true;
                            $scope.$applyAsync();
                        });
                }
            });
        }

        function deleteBand(band) {
            dialog.prompt('delete-band-prompt', function (response) {
                if (response.confirm) {
                    $http.delete('api/bands/' + band.band_slug + '/')
                        .then(function () {
                            band.deleted = true;
                            $scope.$applyAsync();
                        });
                }
            });
        }

        function sendBandToDraft(band) {
            $http.patch('api/send_band_to_draft/' + band.band_slug + '/')
                .then(function (response) {
                    band.drafted = true;
                    $scope.$applyAsync();
                });
        }

        function setAllStar(band, value) {
            $http.patch('api/band/set_all_star/' + band.band_slug + '/' + value + '/')
                .then(function (response) {
                    band.band_all_star = value;
                    $scope.$applyAsync();
                });
        }
    }
})();

